import React, { useRef } from "react";
import SwitchInput from "common/SwitchInputWithState";
import { getFormData, rankAndParseFields } from "../utils";
import VLANs from "./VLANs";
import IPRanges from "./IPRanges";

const NetworksSettings = ({ onInputChange, defaults, bqn, metadata }) => (
  <>
    <p>If enabled, the bypassed traffic will not get any optimization</p>
    <SwitchInput
      defaultChecked={defaults.ipv4}
      className={"sw-input"}
      name={`ipv4[bqn ${bqn}]`}
      value={true}
      label="Bypass IPv4"
      onChange={onInputChange}
      tooltipValues={metadata?.ipv4}
    />
    <SwitchInput
      defaultChecked={defaults.ipv6}
      className={"sw-input"}
      name={`ipv6[bqn ${bqn}]`}
      value={true}
      label="Bypass IPv6"
      onChange={onInputChange}
      tooltipValues={metadata?.ipv6}
    />
    <SwitchInput
      defaultChecked={defaults.mpls}
      className={"sw-input"}
      name={`mpls[bqn ${bqn}]`}
      value={true}
      label="Bypass MPLS"
      onChange={onInputChange}
      tooltipValues={metadata?.mpls}
    />
    <SwitchInput
      defaultChecked={defaults.pppoe}
      className={"sw-input"}
      name={`pppoe[bqn ${bqn}]`}
      value={true}
      label="Bypass PPPoE"
      onChange={onInputChange}
      tooltipValues={metadata?.pppoe}
    />
  </>
);

const BypassSettings = ({ onChange, defaults = {}, state = {}, bqn, metadata }) => {
  const form = useRef(null);
  const onInputChange = () => {
    const values = getFormData(form.current);
    onChange(rankAndParseFields(values, state));
  };
  const onVLANSChange = ({ list, untagged }) =>
    onChange({ ...state, vlans: list, untaggedVLANs: untagged });
  const onIPRangesChange = ({ list }) => onChange({ ipRanges: list });
  return (
    <>
      <h2 className="card-inside-title">Bypass by protocol</h2>
      <form ref={form}>
        <NetworksSettings
          defaults={defaults}
          onInputChange={onInputChange}
          bqn={bqn}
          metadata={metadata}
        />
      </form>
      <VLANs
        defaults={{
          list: defaults.vlans,
          untagged: defaults.untaggedVLANs,
        }}
        onChange={onVLANSChange}
        bqn={bqn}
        metadata={metadata}
      />
      <IPRanges
        defaults={{
          list: defaults.ipRanges,
        }}
        onChange={onIPRangesChange}
        bqn={bqn}
        metadata={metadata}
      />
    </>
  );
};

export default BypassSettings;
